<script setup lang="ts">
/**
 * The purple glow in the top corner of a screen — v1's SimplePageBackground
 * blob: a 176×165 solid purple (glow/strong) under a 110px blur (Blur/Glow),
 * fixed behind the content. Decorative; put it first inside a container with
 * `isolate` so it stays behind that container's content.
 */
</script>

<template>
  <div
    class="pointer-events-none fixed -top-18 -right-5 -z-10 h-41 w-44 rounded-full bg-glow-strong blur-glow"
    aria-hidden="true"
  />
</template>
